import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTenantAdminAuth } from './TenantAdminAuthContext.jsx';

export function RequireTenantAdmin() {
  const { status } = useTenantAdminAuth();
  const location = useLocation();

  if (status === 'loading') return null;
  if (status === 'anonymous') return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}
